import { render, staticRenderFns } from "./RecentFileView.vue?vue&type=template&id=b475cfe6&scoped=true"
import script from "./RecentFileView.vue?vue&type=script&lang=js"
export * from "./RecentFileView.vue?vue&type=script&lang=js"
import style0 from "./RecentFileView.vue?vue&type=style&index=0&id=b475cfe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b475cfe6",
  null
  
)

export default component.exports